const calculatePercentage = (part, total) => {
  if (total === 0) {
    return 0; // To avoid division by zero
  }
  const percentage = (part / total) * 100;
  return Math.round(percentage);
};

export default calculatePercentage;
